import { render, staticRenderFns } from "./ownerRepairManageList.vue?vue&type=template&id=35e53259&scoped=true"
import script from "./ownerRepairManageList.vue?vue&type=script&lang=js"
export * from "./ownerRepairManageList.vue?vue&type=script&lang=js"
import style0 from "./ownerRepairManageList.vue?vue&type=style&index=0&id=35e53259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e53259",
  null
  
)

export default component.exports